import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单字段
      form: {
        prjName: null, // 报建项目名称
        sort: this.$route.query.sort
      },
      // 查询旁边按钮
      searchList: [
        {
          name: "任务提醒",
          type: "success",
          icon: "timer"
        }
      ],
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "工程名称：",
          value: "prjName",
          placeholder: "请输入"
        }
      ],
      // 列表数据
      tableData: [],
      // 列表基础数据
      tableColumns: [
        {
          label: "工程名称",
          prop: "prjName",
          isShow: true,
          minWidth: "300",
          fixed: true,
          align: "left"
        },
        {
          label: "提交时间",
          prop: "submitTime",
          minWidth: "170",
          fixed: true,
          align: "left"
        },
        {
          label: "节点",
          prop: "stepName",
          minWidth: "120",
          fixed: true,
          align: "left"
        },
        {
          label: "备案状态",
          slotName: "op",
          fixed: true,
          width: "150"
        },
        {
          label: "建设单位",
          prop: "buildCorp",
          width: "280"
        },
        {
          label: "立项批准文号",
          prop: "noteNumber",
          width: "150"
        },
        {
          label: "施工单位",
          prop: "constructionUnitName",
          width: "280"
        },
        {
          label: "计划工期（日历天）",
          prop: "planTimeLimit",
          width: "170"
        },
        {
          label: "工程造价（万元）",
          prop: "projectCost",
          width: "150"
        }
      ],
      // 温馨提示
      tipList: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 总条数
      total: 0,
      // 选中的数组
      multipleSelection: []
    };
  },
  // 注册组件
  components: {},
  // 模板编译完成
  mounted() {
    // 执行获取列表数据方法
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开遮罩
      this.loading = true;
      // 发起请求
      fun_PostAction("/contractRecordDirectly/auditList", {
        ...this.form,
        ...this.reqPageData
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.tableData = data.records;
          // 总条数
          this.total = data.total;
          // 关闭遮罩层
          this.loading = false;
        } else {
          // 关闭遮罩层
          this.loading = false;
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 数据字典查询
     * @author 滕威
     */
    fun_Search() {
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查询按钮旁边按钮点击事件
     */
    fun_SearcClick(e) {
      switch (e) {
        case "任务提醒":
          // 跳转到工作台
          this.$router.push({
            path: "/staffWorkbench",
            query: {}
          });
          break;
        default:
      }
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * @description 进入详情
     * @author
     */
    fun_Details(e) {
      // 请求参数
      let obj = {
        controllerFlg: "detail",
        id: e.val.id,
        auditId: e.val.auditId,
        auditType: e.val.auditType
      };
      // 跳转详情页面
      this.$router.push({
        path: "/contractRecordDirectlyAuditDetail",
        // 操作类型
        query: obj
      });
    }
  }
};
